import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MessageHeartSquare = function MessageHeartSquare(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v5.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 18 17.8802 18 16.2 18h-2.5163c-.624 0-.936 0-1.2345.0613a3 3 0 0 0-.7617.2672c-.2713.1386-.515.3335-1.0023.7233l-2.3854 1.9084c-.4161.3329-.6242.4993-.7993.4995a.5.5 0 0 1-.3913-.1881C7 21.1348 7 20.8684 7 20.3355V18c-.93 0-1.395 0-1.7765-.1022a3 3 0 0 1-2.1213-2.1213C3 15.395 3 14.93 3 14z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11.9969 7.6993c-.8997-1.0389-2.4-1.3183-3.5273-.367S7.1836 9.874 8.069 10.999c.5484.697 1.925 1.97 2.8931 2.8379.3556.3187.5333.4781.7467.5423.1831.0551.3934.0551.5764 0 .2134-.0642.3912-.2236.7468-.5423.968-.8679 2.3446-2.1409 2.893-2.8379.8853-1.1251.746-2.7256-.4007-3.6669s-2.6276-.6718-3.5273.367",
      clipRule: "evenodd"
    })]
  }));
};
export default MessageHeartSquare;